import { Field } from 'formik';
import React from 'react';
import { Checkbox, Fieldset, Subsection } from '@fourthwall/components';
export const MarketingEmails = () => {
    return (React.createElement(Subsection, { title: "Marketing emails" },
        React.createElement(Fieldset, null,
            React.createElement(Fieldset.Row, null,
                React.createElement(Fieldset.Item, null,
                    React.createElement(Field, { component: Checkbox, name: 'creatorDigest', label: "Creator Digest", description: "Our monthly newsletter with the latest updates, tips, and creator spotlights" }))),
            React.createElement(Fieldset.Row, null,
                React.createElement(Fieldset.Item, null,
                    React.createElement(Field, { component: Checkbox, name: 'productUpdates', label: "Product updates", description: "Learn about latest updates to the Fourthwall platform" }))),
            React.createElement(Fieldset.Row, null,
                React.createElement(Fieldset.Item, null,
                    React.createElement(Field, { component: Checkbox, name: 'oneOffCampaigns', label: "One-off campaigns", description: "Get notified about promotional offers and community updates" }))))));
};
